import React from 'react';

interface CompareIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function CompareIcon({ 
  color = 'var(--color-primary)', 
  width = 16.4, 
  height = 20.7, 
  ...props 
}: CompareIconProps) {
  return (
    <svg 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink" 
      x="0px" 
      y="0px" 
      width={width}
      height={height}
      viewBox="0 0 16.4 20.7" 
      style={{ overflow: 'visible', enableBackground: 'new 0 0 16.4 20.7' }} 
      xmlSpace="preserve"
      {...props}
    >
      <style type="text/css">
        {`.st0{fill:none;stroke:${color};stroke-width:1.5;stroke-miterlimit:10;stroke-linecap:round;stroke-linejoin:round;}`}
      </style>
      <defs></defs>
      <path className="st0" d="M0.8,16V7.8c0,0-0.5-3.2,3.1-3.2s8.5,0,8.5,0"/>
      <path className="st0" d="M9.5,0.5L13,4.1c0.3,0.3,0.3,0.7,0,0.9L9.9,8.1"/>
      <path className="st0" d="M15.6,4.7v8.2c0,0,0.5,3.2-3.1,3.2s-8.5,0-8.5,0"/>
      <path className="st0" d="M7,20.2l-3.5-3.5c-0.3-0.3-0.3-0.7,0-0.9l3.1-3.1"/>
    </svg>
  );
}